import React, { useState } from "react";
import { Eye, Download } from "lucide-react";

const ImageWithActions = ({ imageUrl, name, altText, API_BASE_URL }) => {
  const [showActions, setShowActions] = useState(false);

  const handleViewImage = () => {
    if (imageUrl) {
      window.open(`${API_BASE_URL}${imageUrl}`, "_blank");
    }
  };

  const handleDownloadImage = async () => {
    if (imageUrl) {
      try {
        const response = await fetch(`${API_BASE_URL}${imageUrl}`);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${name || "image"}.jpg`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error("Error downloading image:", error);
        alert("Failed to download image");
      }
    }
  };

  return (
    <div
      className="position-relative d-inline-block"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
      onClick={() => setShowActions(true)}
    >
      {imageUrl ? (
        <img
          src={`${API_BASE_URL}${imageUrl}`}
          alt={altText || name}
          className="rounded-circle"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            cursor: "pointer",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://ui-avatars.com/api/?name=" +
              encodeURIComponent(name) +
              "&background=random&color=fff&size=50";
          }}
        />
      ) : (
        <div
          className="rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: "60px",
            height: "60px",
            backgroundColor: "#6c757d",
            color: "white",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          {name?.charAt(0).toUpperCase()}
        </div>
      )}

      {imageUrl && showActions && (
        <div
          className="position-absolute top-50 start-50 translate-middle d-flex gap-1"
          style={{ zIndex: 10 }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleViewImage();
            }}
            className="btn btn-sm btn-light shadow-sm"
            title="View Image"
            style={{ padding: "2px 6px" }}
          >
            <Eye size={12} />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadImage();
            }}
            className="btn btn-sm btn-light shadow-sm"
            title="Download Image"
            style={{ padding: "2px 6px" }}
          >
            <Download size={12} />
          </button>
        </div>
      )}

      {showActions && imageUrl && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 rounded-circle"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 5,
          }}
        />
      )}
    </div>
  );
};

export default ImageWithActions;